import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseForm from 'containers/Base/BaseForm';
import { generalSection, validationSchema } from './options';
import { updateUserProfile } from 'reducers/auth';
import { getItemOrDefaultToValue } from 'utils/details';
import { isBase64 } from 'utils/checkImage';
import { HelpLinks } from '../../utils/constants/helpLinks';

const UserProfileForm = ({
  closeForm,
  countries,
  profile,
  updateUserProfile,
}) => {
  const getRole = roleArray => (roleArray.length > 0 ? roleArray[0] : '');

  const initialValues = data => {
    const { phoneNumber, photoUrl, roles, ...values } = data;
    return {
      ...values,
      role: getRole(roles),
      image: photoUrl,
      country: phoneNumber.country,
      phone: phoneNumber.number,
    };
  };

  const onEdit = async values => {
    const { firstName, lastName, image } = values;
    const transformedData = {
      firstName,
      lastName,
      phoneNumber: {
        number: getItemOrDefaultToValue(values, 'phone'),
        country: getItemOrDefaultToValue(values, 'country', '-'),
      },
      ...(isBase64(image) && { photoBase64: image }),
    };
    updateUserProfile(transformedData);
  };

  return (
    <BaseForm
      edit={true}
      initialValues={initialValues(profile)}
      formTitle="Edit User Profile"
      closeForm={closeForm}
      saveHoverText="Update User Profile"
      onSubmit={onEdit}
      allowToArchive={false}
      validationSchema={validationSchema}
      generalSection={generalSection(countries, getRole(profile.roles))}
      formInfo={{
        link: HelpLinks.profileLink,
        value: HelpLinks.profileText,
      }}
    />
  );
};

UserProfileForm.propTypes = {
  closeForm: PropTypes.func,
  countries: PropTypes.array,
  toggleForm: PropTypes.func,
  profile: PropTypes.object,
  updateUserProfile: PropTypes.func,
};

const mapStateToProps = state => ({
  countries: state.utils.countries,
  profile: state.user.general,
});

const mapDispatchToProps = dispatch => ({
  updateUserProfile: data => dispatch(updateUserProfile(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileForm);
